import React, { Component } from 'react';
// import TrackVisibility from 'react-on-screen';
//components

//styles
import './scss/decade.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Data = (props) => {
    return (
        props.data.map((item, i) =>
            <div key={i} className="desc-container">
                <div className="top-data">
                    <h2>{item.SubTitle}</h2>
                    <p>{item.Description}</p>
                </div>
                <div className="data">
                    {item.IndependenceDayYears.map((year, j) =>
                        <div key={j} className="years-container" id={"year-" + year.ID}>
                            <div className="year-circle"></div>
                            <h3 className="year-title">{year.Year}</h3>
                            {year.IndependenceDayEvents.map((event, k) => {
                                if (event.IsMainEvent) {
                                    return (
                                        <div key={k} className="events-container">
                                            <div className="event-circle"></div>
                                            <h3>{event.Title}</h3>
                                            <p>{event.Description}</p>
                                        </div>
                                    )
                                }
                                else {
                                    return (
                                        <div key={k} className={props.showMoreEventsYearId === year.ID ? "events-container hide active" : "events-container hide"}>
                                            <div className="event-circle"></div>
                                            <h3>{event.Title}</h3>
                                            <p>{event.Description}</p>
                                        </div>
                                        )
                                }
                            }
                            )}
                            <div className="close-button">
                                {props.showFloatCloseButton === year.ID && !props.menuOpen ?
                                    <button className="float-close-btn" onClick={() => props.showMoreDetails(year.ID)}>{props.moreButtonText}</button>
                                    : (<button id={"btn_" + year.ID} onClick={() => props.showMoreDetails(year.ID, year.Year)}>{(props.showMoreEventsYearId === year.ID && props.moreButtonText !== "") ? props.moreButtonText : "מה עוד קרה בשנת " + year.Year + "?"}</button>)
                                }
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    );
}

const YearBullet = (props) => {
    let months = [
        "ינואר",
        "פברואר",
        "מרץ",
        "אפריל",
        "מאי",
        "יוני",
        "יולי",
        "אוגוסט",
        "ספטמבר",
        "אוקטובר",
        "נובמבר",
        "דצמבר"
    ];
    return (
        <div className={"bullet-container " + props.className}>
            <div className="close-btn" onClick={() => props.clearBullets()}></div>
            <div className="title">{props.className === "" ? "אלו הדברים שקרו במדינה במהלך חייך" : ""}</div>
            <div className="bullets">
                <div className="bullet-line"></div>
                {props.bullets.map((item, i) =>
                    <div key={i}>
                        <div className="circle"></div>
                        <div className="bullet">
                            <span>{months[item.Month - 1] + " " + item.Year}</span>
                            {"כשהיית בגיל " + ((item.Year - props.year) < 2 ? "שנה" : (item.Year - props.year) === 2 ? "שנתיים" : (item.Year - props.year)) + " " + item.ShortDescription}
                        </div>
                    </div>
                )}
            </div>
            {
                props.className === ""
                    ?
                    <button className="more-bullets-btn" onClick={props.getRandomBullets}>לסיפורים נוספים</button>
                    : ""
            }
        </div>
    )
}

const ErrorYear = (props) => {
    return (
        <div className="error-year-container">
            <div className="error-year">
                <span>השנה שהוזנה אינה תקינה,<br /> אנא הזינו את שנת הלידה שלכם</span>
                <div className="close-btn" onClick={props.closeErrorYear}></div>
            </div>
        </div>
    )
}

class Decade extends Component {
    constructor() {
        super();
        this.showMoreDetails = this.showMoreDetails.bind(this);
        this.getData = this.getData.bind(this);
        this.setData = this.setData.bind(this);
        this.getRandomBullets = this.getRandomBullets.bind(this);
        this.clearBullets = this.clearBullets.bind(this);
        this.showDecadeMenu = this.showDecadeMenu.bind(this);
        this.setBirthdayInput = this.setBirthdayInput.bind(this);
        this.getStories = this.getStories.bind(this);
        this.hideBirthday = this.hideBirthday.bind(this);
        this.enterPressed = this.enterPressed.bind(this);
        this.closeErrorYear = this.closeErrorYear.bind(this);

        this.state = {
            data: [],
            showMoreEventsYearId: 0,
            moreButtonText: "",
            bulletsData: [],
            bulletRandomData: [],
            isDecadeMenuVisible: false,
            birthdayBottom: 0,
            birthday: "",
            showBirthday: true,
            showFloatCloseButton: 0,
            isBottomOfPage: false,
            isErrorYearVisible: false
        }
    }

    showMoreDetails(yearId, yearTitle) {
        this.setState(prevState => ({
            showMoreEventsYearId: prevState.showMoreEventsYearId === yearId ? 0 : yearId,
            moreButtonText: prevState.showMoreEventsYearId === yearId ? "" : "סגור",
            showFloatCloseButton: prevState.showMoreEventsYearId === yearId ? 0 : yearId,
            birthdayBottom: prevState.showMoreEventsYearId === yearId ? prevState.isBottomOfPage ? 40 : prevState.birthdayBottom : 0
        }));
        // window.scroll(0,document.getElementById("year-" + yearId).getBoundingClientRect().top); //this.scrollIntoView("year-" + (yearId -1));


        window.addEventListener('scroll', () => this.handleMoreDetailsButton(yearId));

        if (typeof yearTitle != 'undefined') {
            this.props.sendGA("More_Events_Button", yearTitle);
        }
    }

    showFloatButton(yearId) {
        this.setState({
            showFloatCloseButton: yearId
        });
    }

    handleMoreDetailsButton(yearId) {
        var yearElement = document.getElementById("year-" + yearId);
        if (yearElement !== null && this.state.showMoreEventsYearId === yearId) {
            if (this.isOnScreen(yearElement)) {
                this.showFloatButton(yearId);
            }
            else {
                this.showFloatButton(0);
            }
        }
    }

    isOnScreen(el) {
        var rect = el.getBoundingClientRect(), top = rect.top, height = rect.height, bottom = rect.bottom
        el = el.parentNode;
        do {
            rect = el.getBoundingClientRect();
            if (top <= rect.bottom === false) return false;
            // Check if the element is out of view due to a container scrolling
            if ((top + height) <= rect.top) return false
            // el = el.parentNode;

            if (bottom >= rect.top === false) return false;
            // Check if the element is out of view due to a container scrolling
            if ((bottom - height) >= rect.bottom) return false
            el = el.parentNode;

        } while (el != document.body);
        // Check its within the document viewport
        return top <= document.documentElement.clientHeight && bottom >= document.documentElement.clientHeight;

    };

    componentDidMount() {
        this.setData(this.props.router.match.params.decade);
        window.addEventListener('scroll', () => this.handleScroll(this.state.isDecadeMenuVisible, this.showDecadeMenu));
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.showMoreEventsYearId > 0 && prevState.showMoreEventsYearId != this.state.showMoreEventsYearId) {
            document.body, document.getElementById("year-" + this.state.showMoreEventsYearId).firstElementChild.scrollIntoView();
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.router.match.params.decade !== this.props.router.match.params.decade) {
            window.scrollTo(0, 0);
            this.setData(nextProps.router.match.params.decade);
            nextProps.vPush(nextProps.decadesJSON[nextProps.router.match.params.decade - 1].title);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', () => this.handleScroll(this.state.isDecadeMenuVisible, this.showDecadeMenu));
    }

    async setData(decade) {
        this.setState({
            data: await this.getData("GetByDecade?id=" + decade)
        });
    }

    getData(endUrl) {
        return fetch('https://z.ynet.co.il/mLong/commerce/2018/IndependenceDay70API/api/values/' + endUrl, {
            method: 'GET',
        }).then(response => response.json())
    }

    async getStories() {
        let birthday = 0;
        if (!isNaN(this.state.birthday)) {
            birthday = parseInt(this.state.birthday) + 1;
        }
        if (birthday > 1899 && birthday < 2018) {
            if (this.state.bulletsData.length === 0 || this.state.bulletsData[0].Year !== birthday) {
                this.setState({
                    bulletsData: await this.getData("GetStories?year=" + (birthday))
                });
            }
            this.getRandomBullets();
        }
        else {
            this.setState({
                isErrorYearVisible: true
            });
        }
        this.props.sendGA("Year_Clicked", (birthday - 1));
    }
    getRandomBullets() {
        if (this.state.bulletsData.length <= 3) {
            this.setState({
                bulletRandomData: this.state.bulletsData
            });
        }
        else {
            const shuffled = this.state.bulletsData.sort(() => .5 - Math.random());// shuffle
            this.setState({
                bulletRandomData: shuffled.slice(0, 3).sort(this.dynamicSort("Year"))
            });
        }
    }

    dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    }
    clearBullets(e) {
        this.setState({
            bulletRandomData: [],
            birthday: ""
        });
    }
    showDecadeMenu(show) {
        this.setState(prevState => ({
            isDecadeMenuVisible: show === null ? !prevState.isDecadeMenuVisible : show
        }));
    }

    handleScroll(isDecadeMenuVisible, showDecadeMenu) {
        var decadeImgElement = document.getElementById("decadeImg");
        if (decadeImgElement !== null) {
            if (window.scrollY >= (decadeImgElement.clientHeight) && !isDecadeMenuVisible) {
                showDecadeMenu(true);
            }
            else if (window.scrollY < (decadeImgElement.clientHeight) && isDecadeMenuVisible) {
                showDecadeMenu(false);
            }
        }

        if (window.scrollY >= (document.body.offsetHeight - window.innerHeight)) {
            this.setState({
                birthdayBottom: 40,
                isBottomOfPage: true
            })
        }
        else if (this.state.birthdayBottom === 40) {
            this.setState({
                birthdayBottom: 0,
                isBottomOfPage: false
            })
        }
    }

    hideBirthday(hide) {
        this.setState({
            showBirthday: !hide
        })
    }
    setBirthdayInput(event) {
        this.setState({ birthday: event.target.value });
    }
    enterPressed(event) {
        var code = event.keyCode || event.which;
        if (code === 13) { //13 is the enter keycode
            this.getStories();
        }
    }

    closeErrorYear() {
        this.setState({
            isErrorYearVisible: false
        });
    }

    render() {
        return (
            <div className="decade-container">
                {
                    this.state.isErrorYearVisible
                        ?
                        <ErrorYear closeErrorYear={this.closeErrorYear} />
                        : ""
                }
                <Header
                    bgColor={'#171c25'}
                    height={'80px'}
                    isDecade={true}
                    opacity={0.97}
                    decadeId={this.props.router.match.params.decade}
                    isDecadeMenuVisible={this.state.isDecadeMenuVisible}
                    showDecadeMenu={this.showDecadeMenu}
                    hideBirthday={this.hideBirthday}
                    sendGA={this.props.sendGA}
                    vPush={this.props.vPush}
                />
                <div className="decade-inner-container">
                    <div id="decadeImg" className={"decade-img-" + this.props.router.match.params.decade}></div>
                    <Data
                        data={this.state.data}
                        showMoreDetails={this.showMoreDetails}
                        showMoreEventsYearId={this.state.showMoreEventsYearId}
                        moreButtonText={this.state.moreButtonText}
                        showFloatCloseButton={this.state.showFloatCloseButton}
                        menuOpen={!this.state.showBirthday} />
                    {this.state.showBirthday ?
                        <div className={this.state.bulletRandomData.length > 0 ? "birthday-container bullets" : "birthday-container"} style={{ bottom: this.state.birthdayBottom + "px" }}>
                            <div className="birthday-inner-container">
                                <div className="title">ההיסטוריה של המדינה - ושלכם</div>
                                <div className="input-container">
                                    <input type="text" maxLength="4" value={this.state.birthday} onKeyPress={this.enterPressed} onChange={this.setBirthdayInput} className="inputs" id="birthday" placeholder="הזינו את שנת הלידה שלכם וגלו מה קרה מאז" />
                                    <div className="search-button" onClick={this.getStories}></div>
                                </div>
                            </div>
                            <YearBullet
                                bullets={this.state.bulletRandomData}
                                year={this.state.birthday}
                                getRandomBullets={this.getRandomBullets}
                                clearBullets={this.clearBullets}
                                className={this.state.bulletRandomData.length > 0 ? "" : "hide"}
                            />
                        </div>
                        : ""
                    }
                </div>
                {
                    this.state.showBirthday // menu closed
                        ?
                        <Footer />
                        :
                        ""
                }

            </div>
        );
    }
}

export default Decade;



// WEBPACK FOOTER //
// ./src/Components/Decade/Decade.js